import { render, staticRenderFns } from "./SearchResolutionsList.vue?vue&type=template&id=71fef137&scoped=true&"
import script from "./SearchResolutionsList.vue?vue&type=script&lang=js&"
export * from "./SearchResolutionsList.vue?vue&type=script&lang=js&"
import style0 from "./SearchResolutionsList.vue?vue&type=style&index=0&id=71fef137&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fef137",
  null
  
)

export default component.exports